import {
  createSnapshot,
  snapshot,
  deleteCreditLines,
  removeClientIntegration,
  snapshotAccounts,
  updateSnapshotAccount,
  updateSnapshotAccounts,
  archiveClient,
  deleteClient,
  CLOSE_BANK_DATA_LOADING_ERROR_MODAL,
  CLOSE_BANK_DATA_LOADING_MODAL,
  CLOSE_HEALTH_REPORT,
  CLOSE_CLIENT_PAGE,
  CLOSE_INVITE_CLIENT_MODAL,
  SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE,
  SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE_SUCCESS,
  OPEN_HEALTH_REPORT,
  OPEN_BANK_DATA_LOADING_ERROR_MODAL,
  OPEN_BANK_DATA_LOADING_MODAL,
  SET_CURRENT_MONITOR_PAGE_CLIENT_ID,
  SET_MONITOR_PAGE_TAB,
  OPEN_INVITE_CLIENT_MODAL,
  REMOVE_SNAPSHOT,
  SSE_UPDATE_SNAPSHOT_GENERATION_PROGRESS,
  SET_SNAPSHOT_CREATING,
  SET_NEW_EDIT_FLOW_CLIENT_DATA,
} from './types';

export function requestSnapshot(entityId, promise, updateClientPreview = true) {
  return {
    type: snapshot.request,
    entityId,
    promise,
    updateClientPreview,
  };
}

export function requestSnapshotSuccess(response) {
  return {
    type: snapshot.success,
    response,
  };
}

export function requestSnapshotFailure(error) {
  return {
    type: snapshot.failure,
    error,
  };
}

export function setSnapshotCreating(isLoading) {
  return {
    type: SET_SNAPSHOT_CREATING,
    isLoading,
  };
}

export function closeMonitorBankDataLoadingErrorModal() {
  return {
    type: CLOSE_BANK_DATA_LOADING_ERROR_MODAL,
  };
}

export function closeMonitorBankDataLoadingModal() {
  return {
    type: CLOSE_BANK_DATA_LOADING_MODAL,
  };
}

export function setCurrentMonitorClientId(id) {
  return {
    type: SET_CURRENT_MONITOR_PAGE_CLIENT_ID,
    id,
  };
}

export function setMonitorClientPageTab(number) {
  return {
    type: SET_MONITOR_PAGE_TAB,
    number,
  };
}

export function closeMonitorClientPage() {
  return {
    type: CLOSE_CLIENT_PAGE,
  };
}

export const removeIntegration = (id) => ({
  id,
  type: removeClientIntegration,
});

export const openHealthReport = () => ({
  type: OPEN_HEALTH_REPORT,
});

export const closeHealthReport = () => ({
  type: CLOSE_HEALTH_REPORT,
});

export const requestDeleteCreditLine = (entityId, creditLineId, promise) => ({
  type: deleteCreditLines.request,
  entityId,
  creditLineId,
  promise,
});

export const requestDeleteCreditLineSuccess = (entityId, creditLineId) => ({
  type: deleteCreditLines.success,
  entityId,
  creditLineId,
});

export const requestDeleteCreditLineFailure = (error) => ({
  type: deleteCreditLines.failure,
  error,
});

export function requestSnapshotAccounts(entityId, viewedOnMonitor) {
  return {
    type: snapshotAccounts.request,
    entityId,
    viewedOnMonitor,
  };
}

export function requestSnapshotAccountsSuccess(entityId, response) {
  return {
    type: snapshotAccounts.success,
    entityId,
    response,
  };
}

export function requestSnapshotAccountsFailure(entityId, error) {
  return {
    type: snapshotAccounts.failure,
    entityId,
    error,
  };
}

export function requestUpdateSnapshotAccount(entityId, accountId, payload, promise) {
  return {
    type: updateSnapshotAccount.request,
    entityId,
    accountId,
    payload,
    promise,
  };
}

export function requestUpdateSnapshotAccountSuccess(entityId, accountId, response) {
  return {
    type: updateSnapshotAccount.success,
    entityId,
    accountId,
    response,
  };
}

export function requestUpdateSnapshotAccountFailure(accountId, error) {
  return {
    type: updateSnapshotAccount.failure,
    accountId,
    error,
  };
}

export function requestUpdateSnapshotAccounts(entityId, payload, promise) {
  return {
    type: updateSnapshotAccounts.request,
    entityId,
    payload,
    promise,
  };
}

export function requestUpdateSnapshotAccountsSuccess(entityId, response) {
  return {
    type: updateSnapshotAccounts.success,
    entityId,
    response,
  };
}

export function requestUpdateSnapshotAccountsFailure(entityId, error) {
  return {
    type: updateSnapshotAccounts.failure,
    entityId,
    error,
  };
}

export function closeInviteClientToBankingSolutionModal() {
  return {
    type: CLOSE_INVITE_CLIENT_MODAL,
  };
}

export function openInviteClientToBankingSolutionModal() {
  return {
    type: OPEN_INVITE_CLIENT_MODAL,
  };
}

export function openMonitorBankDataLoadingErrorModal() {
  return {
    type: OPEN_BANK_DATA_LOADING_ERROR_MODAL,
  };
}

export function openMonitorBankDataLoadingModal() {
  return {
    type: OPEN_BANK_DATA_LOADING_MODAL,
  };
}

export function setMonitorClientBalanceSheetViewType(view, classification) {
  return {
    type: SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE,
    view,
    classification,
  };
}

export const setMonitorClientBalanceSheetViewTypeSuccess = () => ({
  type: SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE_SUCCESS,
});

export const triggerSnapshotCreation = (entityId, promise, xeroPayload, blockRefresh) => ({
  type: createSnapshot.request,
  entityId,
  promise,
  xeroPayload,
  blockRefresh,
});

export const updateSnapshot = ({ payload }) => ({
  type: SSE_UPDATE_SNAPSHOT_GENERATION_PROGRESS,
  payload,
});

export const removeSnapshot = (entityId, promise) => ({
  type: REMOVE_SNAPSHOT,
  entityId,
  promise,
});

export const setNewEditFlowClientData = () => ({
  type: SET_NEW_EDIT_FLOW_CLIENT_DATA,
});

export const requestArchiveClient = (entityId, userCompanyId) => ({
  type: archiveClient.request,
  entityId,
  userCompanyId,
});

export const requestDeleteClient = (entityId, userCompanyId) => ({
  type: deleteClient.request,
  entityId,
  userCompanyId,
});
